import { useParams } from 'react-router-dom';

import { OMultiDropdown } from '@src/components';
import CountryBadge from '@src/components/CountryBadge';

import { OButton, ODropdownSplitButton, OResponsiveModal } from '@src/shared';

import { FilterIcon, SearchIcon } from '@src/assets/icons';

import { useAttendeesFilter } from '../useAttendeesFilter';
import styles from '../attendeesFilter.module.scss';

import { IAttendeesFiltersProps } from '@src/types';

const AttendeesFilterMob = ({
  setFilters,
  SelectAll,
  UnselectAll,
  selectedAttendees,
  handleOpenBulkActionModal,
}: IAttendeesFiltersProps) => {
  const { id } = useParams();

  const {
    countries,
    typeOptions,
    draftFilters,
    companyOptions,
    isFilterModalOpen,
    emailDomainOptions,
    setIsFilterModalOpen,
    handleDraftFilterChange,
  } = useAttendeesFilter(id);

  return (
    <div className={styles.container}>
      <div className={styles.actionsContainer}>
        {selectedAttendees.length ? (
          <ODropdownSplitButton
            text={`Un-Select all (${selectedAttendees.length})`}
            onClick={UnselectAll}
            dropdownModel={[
              {
                label: 'Approve',
                command: () => {
                  handleOpenBulkActionModal(true, true);
                },
              },
              {
                label: 'Reject',
                command: () => {
                  handleOpenBulkActionModal(true, false);
                },
              },
            ]}
            size="medium"
          />
        ) : (
          <OButton
            text="Select all"
            variant="primary"
            size="m-small"
            outlined
            onClick={() => {
              SelectAll();
            }}
          />
        )}
        <div className={styles.icons}>
          <img src={SearchIcon} onClick={() => {}} alt="Search icon" />
          <img
            src={FilterIcon}
            onClick={() => {
              setIsFilterModalOpen(true);
            }}
            alt="Filter icon"
          />
        </div>
      </div>

      <OResponsiveModal
        isOpen={isFilterModalOpen}
        onClose={() => {
          setIsFilterModalOpen(false);
        }}
        title="Filters"
        modalClasses={{ container: styles.filterModalContainer }}
        drawerActions={{
          onApply: () => {
            setFilters(draftFilters);
            UnselectAll();
            setIsFilterModalOpen(false);
          },
          cancelLabel: 'Cancel',
          onCancel: () => {
            setIsFilterModalOpen(false);
          },
        }}
        hasBackdrop={true}
      >
        <div className={styles.filterModalContainerDrawer}>
          <OMultiDropdown
            label="Type"
            options={typeOptions}
            value={draftFilters.types}
            onChange={(newValue) => handleDraftFilterChange({ types: newValue })}
            getOptionLabel={(opt) => opt.label}
            height="39px"
          />

          <OMultiDropdown
            label="Email Domain"
            options={emailDomainOptions}
            value={draftFilters.emailDomains}
            onChange={(newValue) => handleDraftFilterChange({ emailDomains: newValue })}
            getOptionLabel={(opt) => opt.label}
            height="39px"
          />

          <OMultiDropdown
            label="Country"
            options={countries}
            value={draftFilters.countries}
            onChange={(newValue) => handleDraftFilterChange({ countries: newValue })}
            renderOption={(c) => <CountryBadge countryCode={c.code} countryName={c.label} />}
            getOptionLabel={(opt) => opt.label}
            height="39px"
            placement="top"
          />

          <OMultiDropdown
            label="Company"
            options={companyOptions}
            value={draftFilters.companies}
            onChange={(newValue) => handleDraftFilterChange({ companies: newValue })}
            getOptionLabel={(opt) => opt.label}
            height="39px"
            placement="top"
          />
        </div>
      </OResponsiveModal>
    </div>
  );
};

export default AttendeesFilterMob;
